import { lazy } from 'react';

// project-imports
import ComponentLayout from '@/layout/Component';
import Loadable from '@/components/base-component/Loadable';

//Encrypt & Decrypt routing
const EncryptDecrypt = Loadable(lazy(() => import('@/pages/examples/backend/enc')));

const ExampleBackendRoutes = {
  path: 'backend',
  element: <ComponentLayout />,
  children: [
    {
      path: 'enc',
      element: <EncryptDecrypt />
    }
  ]
};

export default ExampleBackendRoutes;
